import React from 'react';
import { get, has, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import PageSectionHeading from '../../PageSectionHeading';
import { colors } from '../../../styles';

const styles = css`
  width: 100%;
  padding: 45px 0;
  @media(min-width:768px){
    padding: 90px 0;
  }
/* .Blogpost_sectionTitle {
  font-weight: 400;
  font-size: 36px;
  text-align: center;
  position: relative;
  display: inline-block;
  margin: 0 0 50px 0;
  @media(min-width: 480px) {
    font-size: 36px;
  }
  @media (min-width: 992px) {
    font-size: 48px;
  }
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 20%;
    left: 10%;
    right: 10%;
    bottom: 20%;
    background-color: ${colors.brand3};
    z-index: -1;
    @media (min-width: 992px) {
      left: -10%;
      right: -10%;
    }
  }
} */
.Blogpost_sectionPretitle {
  color: ${colors.brand2};
}
.blogpost {
  display: flex;
  flex-direction: column;
  margin: 0 0 30px 0;
  transition: all .3s ease-out;
  display: block;
  position: relative;
  padding: 0 0 25px 0;
  background: ${colors.white};
  width: 100%;
  box-shadow: 0 10px 15px 0 rgba(0,0,0,0.15);
  @media(min-width: 992px) {
    &:hover {
      @media(min-width: 768px) {
        box-shadow: 0 15px 25px 0 rgba(0,0,0,0.25);
        transform: scale(1.02);
      }
    }
  }
  .blogpost_image {
    width: 100%;
    margin: 0 0 5px 0;
    padding-top: 56.25%;
    background-size: cover;
    background-position: center center;
    border: 15px solid ${colors.white};
  }
  .blogpost_title {
    margin: 0 0 5px 0;
    font-weight: 700;
    font-size: 18px;
    color: ${colors.body};
    line-height: 1.2;
    padding: 0 30px 0 15px;
    @media(min-width: 1200px) {
      font-size: 21px;
    }
  }
  .blogpost_date {
    font-weight: 700;
    font-size: 15px;
    color: ${colors.brand2Darker};
    line-height: 1;
    padding: 0 30px 0 15px;
    margin: 0;
  }
}

`;

function BlogpostsBanner({ blogposts, show, content }) {
  if (blogposts.length < 1) {
    return null;
  }
  return (
    <div className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} />
      }
      <div className="container">
        <div className="row justify-content-center">
          {
            orderBy(blogposts, 'date', 'desc').slice(0, show).map(post => (
              <div className="col-lg-6 col-xl-4" key={post._id}>
                <Link name="blogpost-detail" className="blogpost" params={{ blogpostTitle: post.title }} key={get(post, '_id')}>
                  <div className="blogpost_image" style={{ backgroundImage: `url(${buildThumbnailUrl(post.logo.contentUrl, { width: 800, height: 800 })})` }} />
                  <h3 className="blogpost_title">{get(post, 'title').slice(0, 70)}{get(post, 'title').length > 70 ? '...' : ''}</h3>
                  <h4 className="blogpost_date">
                    {
                      has(post, 'date') &&
                      moment(get(post, 'date')).format('MMMM D, YYYY')
                    }
                  </h4>
                </Link>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

BlogpostsBanner.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.number,
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

BlogpostsBanner.defaultProps = {
  show: 3,
};

export default withData({
  blogposts: true,
})(BlogpostsBanner);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/BlogpostsBanner.section.js